// @ts-nocheck
import React from 'react';
import cx from 'classnames';
import { SortHandle } from './sortable';
import { MenuIcon } from '../icons';

export default class DragHandle extends SortHandle {
  render() {
    const { styles } = DragHandle;

    return (
      <div
        style={this.props.style}
        className={cx(this.props.className, styles.dragIcon)}
      >
        <MenuIcon
          width="18"
          style={{ fill: '#ccc' }}
        />
      </div>
    );
  }
}

const styles = cssInJS({
  dragIcon: {
    width: 18,
    height: 18,
    display: 'inline-block',
    cursor: 'move',
  },
});

DragHandle.styles = styles;
